import { render } from "./PreLoaderComponent.vue?vue&type=template&id=90d54db8&scoped=true"
const script = {}

import "./PreLoaderComponent.vue?vue&type=style&index=0&id=90d54db8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d54db8"]])

export default __exports__